import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import PropertySection from './components/PropertySection';
import EmployeeBenefitsSection from './components/EmployeeBenefitsSection';
import LiabilitySection from './components/LiabilitySection';
import MarineSection from './components/MarineSection';
import EngineeringSection from './components/EngineeringSection';
import TradeCreditSection from './components/TradeCreditSection';
import IndividualsSection from './components/IndividualsSection';
import RiskAssessment from './components/RiskAssessment'; // New import
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-gray-50 text-gray-800">
      <Helmet>
        <title>Yukti Ensure - Clarity in a Complex World</title>
        <meta name="description" content="Your trusted partner for comprehensive insurance solutions. We provide expert guidance on property, liability, marine, and employee benefits to protect what matters most." />
        <meta property="og:title" content="Yukti Ensure - Clarity in a Complex World" />
        <meta property="og:description" content="Your trusted partner for comprehensive insurance solutions. We provide expert guidance on property, liability, marine, and employee benefits to protect what matters most." />
        <meta property="og:image" content="%PUBLIC_URL%/LogoEnsure.png" />
        <meta property="og:url" content="https://www.yukti-ensure.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Yukti Ensure - Clarity in a Complex World" />
        <meta name="twitter:description" content="Your trusted partner for comprehensive insurance solutions. We provide expert guidance on property, liability, marine, and employee benefits to protect what matters most." />
        <meta name="twitter:image" content="%PUBLIC_URL%/LogoEnsure.png" />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Services />
        <div id="knowledge" className="space-y-20 py-20">
          <PropertySection />
          <EmployeeBenefitsSection />
          <LiabilitySection />
          <MarineSection />
          <EngineeringSection />
          <TradeCreditSection />
        </div>
        <IndividualsSection />
        <RiskAssessment /> {/* Render RiskAssessment before ContactUs */}
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
}

export default App;